import { createAction } from "redux-actions";
import { httpClient } from "../../../api/httpClient";
import {
  urlListarAutos,
  urlCrearAuto,
  urlEditarAuto,
  urlEliminarAuto
} from "../api/urls";

// Action Types con Namespace
export const ZERO_AUTOS_LOADING = "ZERO_AUTOS/LOADING";
export const ZERO_AUTOS_HAS_ERRORED = "ZERO_AUTOS/HAS_ERRORED";
export const SET_DATA_AUTOS = "ZERO_AUTOS/SET_DATA_AUTOS";
export const SET_AUTO_SELECCIONADO = "ZERO_AUTOS/SET_AUTO_SELECCIONADO";
export const LIMPIAR_DATOS_AUTOS = "ZERO_AUTOS/LIMPIAR_DATOS_AUTOS";

// Action Creators con Redux-Actions
export const zeroAutosIsLoading = createAction(ZERO_AUTOS_LOADING);
export const zeroAutosHasErrored = createAction(ZERO_AUTOS_HAS_ERRORED);
export const setDataAutos = createAction(SET_DATA_AUTOS);
export const setAutoSeleccionado = createAction(SET_AUTO_SELECCIONADO);
export const limpiarDatosAutos = createAction(LIMPIAR_DATOS_AUTOS);

// --- THUNKS ---

/**
 * Lista todos los vehículos guardados en base de datos.
 */
export const listarAutos = () => async (dispatch) => {
  const empresa = "AIGMETROPOLITANA";
  dispatch(zeroAutosIsLoading(true));
  dispatch(zeroAutosHasErrored(null));
  try {
    const response = await httpClient.get(`${urlListarAutos}&empresa=${empresa}`);
    if (response && response.transaccion !== false && response.autos) {
      dispatch(setDataAutos(response.autos));
    } else {
      dispatch(zeroAutosHasErrored((response && response.errorDescripcion) || "Error desconocido al listar vehículos."));
    }
  } catch (error) {
    dispatch(zeroAutosHasErrored("Excepción al listar vehículos: " + error.message));
  } finally {
    dispatch(zeroAutosIsLoading(false));
  }
};

/**
 * Crea un nuevo vehículo en la colección.
 * @param {object} datos
 * @returns {Promise<boolean>} Indica si fue exitoso
 */
export const crearAuto = (datos) => async (dispatch) => {
  dispatch(zeroAutosIsLoading(true));
  dispatch(zeroAutosHasErrored(null));
  try {
    const response = await httpClient.post(urlCrearAuto, datos);
    if (response && response.transaccion !== false) {
      dispatch(listarAutos());
      return true;
    } else {
      dispatch(zeroAutosHasErrored((response && response.errorDescripcion) || "Error al crear el vehículo."));
      return false;
    }
  } catch (error) {
    dispatch(zeroAutosHasErrored("Excepción al crear el vehículo: " + error.message));
    return false;
  } finally {
    dispatch(zeroAutosIsLoading(false));
  }
};

/**
 * Actualiza un vehículo existente utilizando PATCH.
 * @param {string} id
 * @param {object} datos
 * @returns {Promise<boolean>} Indica si fue exitoso
 */
export const editarAuto = (id, datos) => async (dispatch) => {
  dispatch(zeroAutosIsLoading(true));
  dispatch(zeroAutosHasErrored(null));
  try {
    const response = await httpClient.patch(`${urlEditarAuto}${id}`, datos);
    if (response && response.transaccion !== false) {
      dispatch(listarAutos());
      return true;
    } else {
      dispatch(zeroAutosHasErrored((response && response.errorDescripcion) || "Error al actualizar el vehículo."));
      return false;
    }
  } catch (error) {
    dispatch(zeroAutosHasErrored("Excepción al actualizar el vehículo: " + error.message));
    return false;
  } finally {
    dispatch(zeroAutosIsLoading(false));
  }
};

/**
 * Elimina un vehículo utilizando DELETE.
 * @param {string} id
 * @returns {Promise<boolean>} Indica si fue exitoso
 */
export const eliminarAuto = (id) => async (dispatch) => {
  dispatch(zeroAutosIsLoading(true));
  dispatch(zeroAutosHasErrored(null));
  try {
    const response = await httpClient.delete(`${urlEliminarAuto}${id}`);
    if (response && response.transaccion !== false) {
      dispatch(listarAutos());
      return true;
    } else {
      dispatch(zeroAutosHasErrored((response && response.errorDescripcion) || "Error al eliminar el vehículo."));
      return false;
    }
  } catch (error) {
    dispatch(zeroAutosHasErrored("Excepción al eliminar el vehículo: " + error.message));
    return false;
  } finally {
    dispatch(zeroAutosIsLoading(false));
  }
};
